<template>
  <div
    :class="[rowData.headerTip ? 'card-container-headerTip' : 'card-container']"
    @click="goLogistics"
  >
    <div class="card-header" v-if="rowData.headerTip">
      {{ rowData.headerTip }}
    </div>
    <div class="card-wrap">
      <div class="card-body">
        <div class="card-body-header">
          <div class="card-body-header-left">
            <span class="card-body-header-left-subject">{{
              this.rowData.subjectName
                ? this.rowData.subjectName.substring(0, 1)
                : ""
            }}</span>
            {{ rowData.productName }}
          </div>
          <div
            :class="[
              'card-body-header-right',
              rowData.sendBackStatus ? 'card-body-header-right-done' : '',
              rowData.status === 5 || rowData.status === 6
                ? 'card-body-header-right-warning'
                : '',
            ]"
          >
            {{ rowData.statusName }}
          </div>
        </div>
        <div
          :class="[
            'card-body-body',
            rowData.logisticsText &&
            !rowData.sendBackText &&
            !rowData.addAddressText
              ? 'card-body-body-nomargin'
              : '',
          ]"
        >
          <span @click="setDetailState"
            ><span style="margin-right: 0.12rem">{{
              rowData.status === 10 ? "退回教材" : "教材资料"
            }}</span
            ><span>{{ rowData.goods.length }}件</span></span
          >
          <div
            @click="setDetailState"
            style="padding-right: 0.4rem; transform: 'translateY(-.02rem)'"
          >
            <img
              v-show="showDetail"
              src="../../../assets/img/myPackage/arrow_right_grey2.png"
              alt=""
            />
            <img
              v-show="!showDetail"
              src="../../../assets/img/myPackage/arrow_right_grey.png"
              alt=""
            />
          </div>
        </div>
        <div class="card-body-detail" v-show="showDetail">
          <p :key="index" v-for="(item, index) in rowData.goods">
            教材{{ index + 1 }}：{{ item.name }}
          </p>
        </div>
      </div>
      <div
        class="card-footer"
        v-if="
          rowData.addAddressText ||
          rowData.logisticsText ||
          rowData.sendBackText
        "
      >
        <!-- 查看物流按钮 -->
        <button
          v-if="rowData.logisticsText"
          class="card-footer-btn-normal"
          @click="footGoLogistics"
        >
          {{ rowData.logisticsText }}
        </button>
        <!-- 退回教材按钮 -->
        <button
          v-if="rowData.sendBackText"
          class="card-footer-btn-normal"
          @click="goSendBackBtn"
        >
          {{ rowData.sendBackText }}
        </button>
        <button
          v-if="rowData.addAddressText"
          class="card-footer-btn-addAddress"
          @click="goAddAddress"
        >
          {{ rowData.addAddressText }}
        </button>
      </div>

      <van-popup
        v-model="modal_returnList"
        round
        position="bottom"
        get-container="body"
      >
        <div class="innerBox">
          <div class="topInfo">
            <div class="topTitle">选择要退回的教材</div>
            <button class="closeBtn" @click="closePop"></button>
          </div>
          <div class="content">
            <div class="cell" v-for="(item, index) in goods" :key="index">
              <div
                class="content-row-box"
                :disabled="item.sendBackStatus !== 1"
                :checked="item.isChecked"
                @click="checkboxOnChange(index)"
              >
                <img :src="item | checkboxImg" />

                <div class="imgbox">
                  <img
                    :src="item.image"
                    alt=""
                    :style="[
                      item.sendBackStatus !== 1 ? 'border-radius:0.08rem' : '',
                    ]"
                  />
                </div>
                <div
                  v-if="item.sendBackStatus === 1"
                  class="packageNameContainer"
                >
                  <div class="packageName" style="color: #333333">
                    {{ item.name }}
                  </div>
                </div>
                <div v-else class="packageNameContainer">
                  <span class="packageName" style="color: #999999; flex: 1">{{
                    item.name
                  }}</span>
                </div>
                <span class="rightStatus" v-if="item.sendBackStatus !== 1"
                  >已退回</span
                >
              </div>
            </div>
          </div>
          <div class="popFooter">
            <div class="checkboxall_box" @click="checkAll">
              <img :src="checkboxImgAll" />
              <span class="allCheckText">全选</span>
            </div>
            <button
              :class="[
                'modal_returnList_wrapper_submit',
                checkedNum > 0 ? 'modal_returnList_wrapper_submit_active' : '',
              ]"
              @click="goReturnInfoFullIn"
            >
              确定<span v-if="checkedNum > 0">({{ checkedNum }})</span>
            </button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "card",
  data() {
    return {
      showDetail: false,
      modal_returnList: false,
      goods: [],
      checkedNum: 0,
      allChecked: false,
      isJumping: false,
    };
  },
  props: {
    rowData: {
      type: Object,
    },
    status: {
      type: Number,
    },
  },
  computed: {
    checkboxImgAll() {
      if (this.goods.every((good) => good.sendBackStatus !== 1)) {
        return require("../../../assets/img/myPackage/disabled.png");
      } else {
        if (this.allChecked) {
          return require("../../../assets/img/myPackage/selected.png");
        } else {
          return require("../../../assets/img/myPackage/notselected.png");
        }
      }
    },
  },

  mounted() {
    console.log(2222, this.rowData);
  },
  filters: {
    checkboxImg: function (item) {
      if (item.sendBackStatus == 1) {
        if (item.isChecked) {
          return require("../../../assets/img/myPackage/selected.png");
        } else {
          return require("../../../assets/img/myPackage/notselected.png");
        }
      } else {
        return require("../../../assets/img/myPackage/disabled.png");
      }
    },
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),

    goLogistics() {
      const bizId = this.rowData.bizId;
      const multiplePackage = this.rowData.multiplePackage;

      const status = this.status;
      if (status === 10) {
        this.$router.push({
          path: "/returnDetail",
          query: { mrbNum: this.rowData.mrbNum, tab: status },
        });
        return;
      }
      if (multiplePackage) {
        this.$router.push({
          path: "/multiplePackages",
          query: { bizId: bizId, tab: status },
        });
      } else {
        this.$router.push({
          path: "/logisticsDetail",
          query: { bizId: bizId, tab: status },
        });
      }
    },
    setDetailState(e) {
      e.stopPropagation();
      this.showDetail = !this.showDetail;
    },
    footGoLogistics() {},
    goSendBackBtn(e) {
      this.allChecked = false;
      this.checkedNum = 0;
      e.stopPropagation();
      this.$dialog
        .confirm({
          confirmButtonText: "我已确认",
          message: "退回前，请先与班主任或顾问沟通确认",
        })
        .then(() => {
          // on confirm
          this.openPackageModal();
        })
        .catch(() => {
          // on cancel
        });
    },
    openPackageModal() {
      this.changeLoading(true);
      this.$api.my
        .geSendBackChooses({
          bizId: this.rowData.bizId,
        })
        .then((res) => {
          this.changeLoading(false);
          if (res.ret) {
            this.modal_returnList = true;
            this.goods = res.data.goods;
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.changeLoading(false);
        });
    },
    goAddAddress(e) {
      e.stopPropagation();
      window.dhsdk.goAddressListPage({
        orderId: this.rowData.orderId,
        enrollId: this.rowData.enrollId,
      });
    },
    closePop() {
      this.modal_returnList = false;
    },
    checkboxOnChange(idx) {
      let _goods = this.goods;
      _goods[idx].isChecked = !_goods[idx].isChecked;
      this.goods = _goods;
      this.checkedNum = _goods
        .filter((item) => item.sendBackStatus === 1)
        .filter((item) => item.isChecked).length;
      if (_goods[idx].isChecked) {
        if (
          this.goods
            .filter((item) => item.sendBackStatus === 1)
            .every((good) => good.isChecked)
        ) {
          this.allChecked = true;
        }
      } else {
        this.allChecked = false;
      }
    },
    checkAll() {
      if (this.goods.every((good) => good.sendBackStatus !== 1)) {
        return;
      }
      if (!this.allChecked) {
        let _goods = this.goods;
        _goods.forEach((item) => {
          if (item.sendBackStatus == 1) {
            item.isChecked = true;
          }
        });
        this.goods = _goods;
        this.allChecked = true;
        this.checkedNum = _goods.filter(
          (item) => item.sendBackStatus === 1
        ).length;
      } else {
        let _goods = this.goods;
        _goods.forEach((item) => {
          item.isChecked = false;
        });
        this.goods = _goods;
        this.allChecked = false;
        this.checkedNum = 0;
      }
    },
    goReturnInfoFullIn() {
      if (this.checkedNum <= 0) return;
      if (this.isJumping === true) return;

      this.isJumping = true;
      let goodsIds = this.goods
        .filter((item) => item.isChecked)
        .map((item) => item.id)
        .join(",");
      this.$router.push({
        path: "/returnInfoFullIn",
        query: {
          tab: this.status,
          goodsIds: goodsIds,
          orderId: this.rowData.orderId,
          bizId: this.rowData.bizId,
          subject: this.rowData.subjectName,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.card-header {
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(161, 109, 54, 1);
  background: rgba(255, 242, 219, 1);
  padding: 0 16px;
  border-radius: 6px;
}
.card-container {
  margin: 12px;
  margin-top: 0;
  overflow: hidden;
}
.card-container-headerTip {
  margin: 12px;
  margin-top: 0;
  margin-bottom: 4px;
  overflow: hidden;
  .card-wrap {
    transform: translateY(-8px);
  }
}
.card-wrap {
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  padding: 16px;
  z-index: 10;
  // transform: translateY(-.16rem);

  .card-body-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 9px;

    &-left {
      font-size: 18px;
      line-height: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      flex: 1;

      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

      &-subject {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        transform: translateY(-2px);
        background: rgba(250, 229, 231, 1);
        border-radius: 2px;
        font-size: 12px;
        color: rgba(205, 0, 20, 1);
        text-align: center;
        vertical-align: center;
        margin-right: 6px;
      }
    }

    &-right {
      font-size: 14px;
      line-height: 25px;
      height: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 121, 40, 1);
      width: 66px;
      margin-left: 10px;
      text-align: right;
    }
    &-right-done {
      color: #999999;
    }
    &-right-warning {
      color: #cd0014;
    }
  }

  .card-body-body {
    line-height: 14px;
    height: 14px;
    margin-bottom: 12px;
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);

    &-nomargin {
      margin-bottom: 0;
    }

    img {
      width: 14px;
      height: 14px;
      margin-left: 4px;
    }
  }
  .card-body-detail {
    p {
      font-size: 14px;
      line-height: 1.4;
      margin-top: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
    p:last-of-type {
      margin-bottom: 12px;
    }
  }

  .card-footer {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid rgba(242, 242, 242, 1);
    padding-top: 16px;

    &-btn-normal {
      width: 88px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid rgba(226, 226, 226, 1);
      background-color: transparent;

      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 14px;
      margin-left: 10px;
    }

    &-btn-addAddress {
      background: rgba(205, 0, 20, 1);
      border: 1px solid rgba(226, 226, 226, 1);
      border-radius: 15px;
      width: 116px;
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 14px;
      margin-left: 10px;
    }
  }
}
.innerBox {
  .topInfo {
    background: #ffffff;
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 15px;
    // font-family: PingFangSC-Medium, PingFang SC;
    // font-weight: 500;
    color: #212832;
    position: relative;
    border-bottom: 1px solid #eee;
    .closeBtn {
      border: none;
      position: absolute;
      width: 16px;
      height: 16px;
      background: url("../../../assets/img/close.png") no-repeat 0 0;
      background-size: contain;
      top: 50%;
      transform: translateY(-47%);
      right: 16px;
    }
  }
  .content {
    // padding: 16px 20px;
    height: 260px;
    color: #212832;
    position: relative;
    font-weight: 400;
    font-size: 15px;
    overflow: auto;
    // margin-bottom: 100px;
    .cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 0;
      overflow: hidden;
      color: #323233;
      font-size: 14px;
      line-height: 24px;
      background-color: #fff;
    }
    .cell::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
}
.imgbox {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 10px;
}
.checkboxall_box {
  display: flex;
  > img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.content-row-box {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  min-height: 44px;
  background-color: #fff;
  vertical-align: middle;
  overflow: hidden;
  -webkit-transition: background-color 200ms;
  transition: background-color 200ms;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: left;
  margin-bottom: 16px;
  width: 100%;
  &:last-of-type {
    margin-bottom: 0;
  }

  img {
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }
  > img {
    width: 20px;
    height: 20px;
  }

  .packageNameContainer {
    flex: 1;
    line-height: 20px;
    display: flex;
    align-items: center;
  }
  .packageName {
    position: relative;
    line-height: 20px;
    font-size: 13px;
    flex: 1;
    color: #333333;
    white-space: normal;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  span.rightStatus {
    width: 42px;
    display: flex;

    justify-content: right;
    align-items: center;
    margin-left: 20px;
    font-size: 13px;
    color: rgba(237, 125, 58, 1);
  }
}
.popFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  border-top: 1px solid #f0f0f0;
  padding: 0 20px;
}
.allCheckText {
  color: #666666;
  font-size: 14px;
  line-height: 20px;
}
.modal_returnList_wrapper_submit {
  border: none;
  width: 100px;
  height: 40px;
  background: rgba(226, 226, 226, 1);
  border-radius: 4px;
  font-size: 15px;
  color: rgba(153, 153, 153, 1);

  &_active {
    background: rgba(205, 0, 20, 1);
    color: rgba(255, 255, 255, 1);
  }
}
</style>
